/**
 * Formats the location object for use in `DhlDropdown` component.
 * The JSON `value` can be parsed with `parseLocation` function.
 *
 * @param {{city: string, postalCode: string|undefined}} props
 * @returns {{label: string, value: string}}
 */
export function formatLocation({ city, postalCode }) {
  // TODO: Why Postal Location API returns all-caps on everything?
  const formattedCity = city
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

  return {
    label: `${formattedCity}${postalCode ? `, ${postalCode}` : ""}`,
    value: JSON.stringify({ city: formattedCity, postalCode }),
  };
}
